import * as yup from 'yup';
import { regExp } from 'common/constants/regExp';
import { pastOrTodayDateSchema } from 'common/validationSchemas/dateSchemas';
import { phoneSchema } from 'common/validationSchemas/phoneSchema';
import { getAddressSchema } from 'common/validationSchemas/addressSchema';
import inputErrors from 'common/messages/inputErrors';
import message from 'modules/crm/messages/leads';
import { cameFromFieldsSchema } from 'common/validationSchemas/cameFromFieldsSchema';
import { TShortProfileFieldInfoImt } from 'modules/corporate-settings/interfaces';
import {
  FieldNecessity,
  RequiredProfileInfo,
} from 'modules/corporate-settings/constants/requiredFields';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { getEmailErrorMessage, getRequiredErrorMessage } from 'common/utils/validation';
import validationMessages from 'common/messages/validation';

export const PrimaryInfoStepValidationSchema = (
  employees: IEmployeeBasicInfo[],
  requiredFields: TShortProfileFieldInfoImt,
): yup.AnyObjectSchema => {
  // TODO: Refactoring is needed
  return yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .matches(regExp.NAME, () => validationMessages.lettersOnly)
      .required(getRequiredErrorMessage),
    lastName: yup
      .string()
      .trim()
      .matches(regExp.NAME, () => validationMessages.lettersOnly)
      .required(getRequiredErrorMessage),
    birthday: pastOrTodayDateSchema.when(RequiredProfileInfo.Birthday, {
      is: () => requiredFields.get(RequiredProfileInfo.Birthday) === FieldNecessity.Required,
      then: schema => schema.required(getRequiredErrorMessage),
      otherwise: schema => schema,
    }),
    gender: yup.string().required(getRequiredErrorMessage),
    email: yup
      .string()
      .nullable()
      .trim()
      .email(getEmailErrorMessage)
      .when(RequiredProfileInfo.Email, {
        is: () => requiredFields.get(RequiredProfileInfo.Email) === FieldNecessity.Required,
        then: schema => schema.required(getRequiredErrorMessage),
        otherwise: schema => schema,
      }),
    address: getAddressSchema(requiredFields),
    pinCode: yup
      .string()
      .nullable()
      .notRequired()
      .when({
        is: val => val?.length,
        then: rule => rule.min(4, () => inputErrors.pinCodeLengthError),
      }),
    phones: yup
      .array(
        yup.object().shape({
          phone: phoneSchema.nullable().required(getRequiredErrorMessage),
        }),
      )
      .test({
        message: getRequiredErrorMessage,
        test: arr =>
          requiredFields.get(RequiredProfileInfo.PhoneNumber) !== FieldNecessity.Required ||
          !!arr?.length,
      }),
    limitations: yup
      .string()
      .max(1000, () => inputErrors.salesInfoLengthError)
      .nullable(),
    assignedSalesperson: yup.mixed().when((employ, schema) => {
      if (employ?.id) {
        const isExistEmployee = Boolean(
          employees.find(item => {
            return item.id === Number(employ.id);
          }),
        );

        if (!isExistEmployee) {
          return schema.test(
            'salesperson',
            () => message.selectedSalespersonNotListAvailable,
            () => false,
          );
        }
      }

      if (requiredFields.get(RequiredProfileInfo.Salesperson) === FieldNecessity.Required) {
        return schema
          .notOneOf(['', null], getRequiredErrorMessage)
          .required(getRequiredErrorMessage);
      }

      return schema;
    }),
    preferableWayOfCommunication: yup
      .string()
      .nullable()
      .required(getRequiredErrorMessage),
    image: yup
      .object()
      .nullable()
      .when(RequiredProfileInfo.Photo, {
        is: () => requiredFields.get(RequiredProfileInfo.Photo) === FieldNecessity.Required,
        then: schema => schema.required(getRequiredErrorMessage),
        otherwise: schema => schema,
      }),
    ...cameFromFieldsSchema,
  });
};
